import React, { Component } from 'react';
import { connect } from 'react-redux';
import propTypes from 'prop-types';
import handleInsertOrganization from './utils/insertOrganization';
import { DragHandler } from '../../../../../editJournal/toolset/assets/icons';
import componentSection from '../../../LeftPane/componentSection';
import Actions from '../../../../../../../../store/actions';
import cardDragStartHandler from './Drag/cardDragStartHandler';
import cardDragEndHandler from './Drag/cardDragEndHandler';
import SnackBarAlerts from '../../../../../../../common/snackBarAlerts/snackBarAlerts';
import scrollToElement from './utils/scrollToElement';
import Logger from '../../../../../../../../utility/services/Logger';
import {
  Wrapper,
  OrdinalWrapper,
  DragWrapper,
  Ordinal,
  Children,
  OrganizationButtonsWrapper,
} from '../../../../../UI/Editor/EditSpace/EditorPane/RenderContent/renderOrganization';
import { isFirefox, isSafari } from '../../../../../../../../utility/browsers';
import Buttons from './OrganizationDetails/buttons';
import exportOrganization from './OrganizationDetails/exportOrganization';
import deleteOrganization from './OrganizationDetails/deleteOrganization';

class Organization extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentCollapse: false,
      noDrag: false,
      snackBar: null,
      expandedHeight: null,
    };
    this.childrenRef = React.createRef();
  }

  onDragStart = (e) => {
    const { noDrag } = this.state;

    const nativeSelection = window.getSelection().toString().length;
    if (nativeSelection) {
      e.preventDefault();
      return;
    }

    if (noDrag) {
      e.preventDefault();
      this.setDrag(false);
      return;
    }

    try {
      const {
        nodeProps: {
          editor,
          node: { key: nodeKey },
        },
        collapse,
        setCollapse,
      } = this.props;

      editor.blur(); // to prevent default insertion

      /**
       * No drag when only one org
       */
      const {
        value: {
          document: {
            nodes: { size: documentNodesSize },
          },
        },
      } = editor;
      if (documentNodesSize === 1) {
        e.preventDefault();
        return;
      }

      cardDragStartHandler({
        e,
        editor,
        collapse,
        nodeKey,
        dragType: 'ORGANIZATION',
        setCollapse,
        setSnackBar: this.setSnackBar,
      });
    } catch (err) {
      Logger.LogError(err);
      this.setSnackBar('error');
    }
  };

  onDragEnd = (e) => {
    e.preventDefault();
    const { snackBar } = this.state;

    if (snackBar && snackBar.errorCode === 'drag') {
      const { target: el } = e;
      scrollToElement(el);
      return;
    }

    try {
      const {
        nodeProps: { editor, node },
        collapse,
        setCollapse,
        dragOverCords,
        mostUsedToolSetRef,
        statusBarRef,
      } = this.props;
      editor.blur(); // to prevent default insertion

      cardDragEndHandler({
        e,
        editor,
        node,
        collapse,
        dragType: 'ORGANIZATION',
        setCollapse,
        dragOverCords,
        mostUsedToolSetRef,
        statusBarRef,
      });
    } catch (err) {
      Logger.LogError(err);
      this.setSnackBar('error');
    }
  };

  setDrag = (val) =>
    this.setState({
      noDrag: val,
    });

  stopDrag = () => this.setDrag(true);

  handleCloseSnackBar = () => {
    this.setState({ snackBar: null });
  };

  setSnackBar = (type) => {
    if (type === 'error')
      this.setState({
        snackBar: {
          showSnackBar: true,
          snackBarMessage: 'Please, retry the dragging!',
          snackBarType: 'error',
          errorCode: 'drag',
        },
      });
  };

  signifierClick = () => {
    const {
      nodeProps: { editor },
    } = this.props;
    editor.blur();
    this.setDrag(false);
  };

  handleExport = (e) => {
    e.preventDefault();
    const { nodeProps } = this.props;
    const { editor, node } = nodeProps;
    exportOrganization({ editor, node, props: this.props });
  };

  handleDelete = (e) => {
    e.preventDefault();
    const { nodeProps } = this.props;
    const { editor, node } = nodeProps;
    deleteOrganization({ e, node, editor });
  };

  render() {
    const {
      nodeProps,
      editor,
      collapse: { document },
      dragType,
    } = this.props;
    const { node, isFocused } = nodeProps;
    const { node: currentOrganization, attributes, children } = nodeProps;
    const { data: orgData, type } = currentOrganization;
    const ordinal = orgData.get('Ordinal');
    const ordinalString = ordinal && `${ordinal}.`;

    // get collapse state from node
    const isCollapseOrg = orgData.get('isCollapseChildren');

    const {
      value: {
        document: { key: documentKey },
      },
    } = editor;
    const { [documentKey]: documentCollapse } = document || {};
    const { currentCollapse, snackBar } = this.state;

    /**
     * NOTE: Update this condition when using collapse buttons accordingly
     */
    const collapseOrg =
      (documentCollapse && dragType === 'ORGANIZATION') ||
      currentCollapse ||
      isCollapseOrg;

    const organizationParent =
      currentOrganization &&
      editor.value.document.getParent(currentOrganization.key);
    const organizationCount =
      organizationParent && organizationParent.nodes.size;

    const selectAll =
      currentOrganization && currentOrganization.data.get('selectAll');

    const rolesCount =
      currentOrganization && currentOrganization.nodes.size - 1;
    const mark = rolesCount === selectAll;

    const isCollapseChildren =
      currentOrganization && currentOrganization.data.get('isCollapseChildren');

    const {
      expandedHeight,
      collapseHeight,
      collapseMarginTop,
      collapseMarginBottom,
    } = this.state;

    return (
      <>
        {snackBar && (
          <SnackBarAlerts
            showSnackBar={snackBar.showSnackBar}
            handleClose={this.handleCloseSnackBar}
            snackBarMessage={snackBar.snackBarMessage}
            snackBarType={snackBar.snackBarType}
          />
        )}
        <Wrapper
          {...attributes}
          className="draggable organization"
          draggable
          onDragStart={this.onDragStart}
          onDragEnd={this.onDragEnd}
          type={type}
          dragType={dragType}
          isSafari={isSafari}
          isFirefox={isFirefox}
          suppressContentEditableWarning
        >
          <OrdinalWrapper contentEditable={false} nodeType={type}>
            <DragWrapper
              className="drag-signifier"
              currentCollapse={collapseOrg}
              onMouseDown={this.signifierClick}
              nodeType={type}
              title="Drag to reorder"
            >
              <DragHandler width="20px" height="20px" />
            </DragWrapper>
            {type !== 'skill_organization' && (
              <Ordinal>{ordinalString}</Ordinal>
            )}
          </OrdinalWrapper>
          <Children
            ref={this.childrenRef}
            nodeType={type}
            onMouseDown={this.stopDrag}
            isCollapseChildren={isCollapseChildren}
            isFocused={isFocused}
            childrenRef={this.childrenRef}
            expandedHeight={expandedHeight}
            collapseHeight={collapseHeight}
            collapseMarginTop={collapseMarginTop}
            collapseMarginBottom={collapseMarginBottom}
          >
            {collapseOrg ? <>{children[0]}</> : <>{children}</>}
          </Children>
          <OrganizationButtonsWrapper isFocused={isFocused}>
            <Buttons
              mark={selectAll !== 0 ? 'true' : 'false'}
              selectAll={mark}
              rolesCount={organizationCount}
              handleDelete={this.handleDelete}
              handleExport={this.handleExport}
              node={node}
              stopDrag={this.stopDrag}
              nodeType={type}
              handleInsertOrganization={handleInsertOrganization}
              editor={editor}
              currentOrdinal={ordinal}
              currentOrganization={currentOrganization}
              isFocused={isFocused}
            />
          </OrganizationButtonsWrapper>
        </Wrapper>
      </>
    );
  }
}

Organization.propTypes = {
  nodeProps: propTypes.objectOf(propTypes.object).isRequired,
  children: propTypes.node.isRequired,
  currentOrganization: propTypes.objectOf(propTypes.object).isRequired,
  attributes: propTypes.objectOf(propTypes.string).isRequired,
  editor: propTypes.shape({
    resolveController: propTypes.func.isRequired,
  }).isRequired,
  updateExport: propTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const {
    nodeProps: {
      node: { type },
    },
  } = ownProps;
  const sectionKey = componentSection[type];
  return {
    [sectionKey]: state.editResumeFormReducer[sectionKey],
    collapse: state.editResumeFormReducer.collapse,
    dragType: state.editResumeFormReducer.dragType,
    dragOverCords: state.editResumeFormReducer.dragOverCords,
  };
};

const mapDispatchToProps = (dispatch) => ({
  setCollapse: (params) =>
    dispatch(Actions.editResumeFormActions.setCollapse(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Organization);
